import { IRadObject, Property, RadObject, RadObjectPropertyValues } from "../RadObject";
import { NAMESPACE } from "./_Namespace";

export interface IPropertyComparerRegistration
{
    id: string;
    description: string;
    instance: PropertyComparer;
    operator: string;
}

export type PropertyComparerPropertyValues =
    RadObjectPropertyValues
    & {
    };

export type PropertyComparerProperties = {
    [name in keyof PropertyComparerPropertyValues]: Property<PropertyComparerPropertyValues[name]>
};

export interface IPropertyComparer extends IRadObject, PropertyComparerProperties
{
}

export abstract class PropertyComparer<TPropertyValues extends PropertyComparerPropertyValues = PropertyComparerPropertyValues> extends RadObject<TPropertyValues> implements IPropertyComparer
{
    // #region Static

    public static override classNamespace = NAMESPACE + "PropertyComparer";
    public static override className = "PropertyComparer";

    // #region Properties

    public static propertyComparers: IPropertyComparerRegistration[] = [];

    // #endregion

    // #region Public Methods

    public static registerPropertyComparer(propertyComparerRegistration: IPropertyComparerRegistration)
    {
        this.propertyComparers.push(propertyComparerRegistration);
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Public Methods

    public compare(propertyValue: any, constantValue: any): boolean
    {
        throw new Error("compare has not been implemented");
    }

    // #endregion

    // #endregion
}
